// The persisted user token carries a fixed suffix appended at store time
// (store.ts) so the raw JWT is never the literal value held in storage. Every
// authenticated request must strip the suffix before sending the bearer token.
// Centralised here so the literal lives in exactly one place (§2c/§2d) — the
// ~20 inline `token.replace("B9I9N9456", "")` call sites can adopt this helper
// when next touched.
export const STORED_USER_TOKEN_SUFFIX = "B9I9N9456";

// Strip only a *trailing* suffix — the marker is appended at the end at store
// time, so a plain `.replace()` (first match anywhere) could corrupt a raw JWT
// whose base64 payload happens to contain the marker substring.
export function stripStoredUserTokenSuffix(token: string): string {
  return token.endsWith(STORED_USER_TOKEN_SUFFIX)
    ? token.slice(0, -STORED_USER_TOKEN_SUFFIX.length)
    : token;
}
